import Vue from 'vue'
import App from '@/models/App'
import Ship from '@/models/Ship'
import Organization from '@/models/Organization'

export default class ShipSpareSummary extends App {
    static get entity() {
        return 'ShipSpareSummaries'
    }
    static findByShipId(id) {
        return this.query().where('shipId', id).withAllRecursive().first()
    }
    static all() {
        return this.query()
            .withAllRecursive()
            .orderBy('$isNew', 'desc')
            .orderBy('id', 'desc')
            .get()
    }
    static fields() {
        return {
            id: this.uid(),
            organizationId: this.attr(''),
            shipId: this.attr(''),
            deckPrice: this.attr(0),
            enginePrice: this.attr(0),
            otherPrice: this.attr(0),
            totalPrice: this.attr(0),
            deckItem: this.attr(0),
            engineItem: this.attr(0),
            otherItem: this.attr(0),
            totalItem: this.attr(0),
            organization: this.belongsTo(Organization, 'organizationId'),
            ship: this.belongsTo(Ship, 'shipId'),
        }
    }
    static apiConfig = {
        actions: {
            fetch(shipId) {
                return this.get(`${shipId}/spares/summaries`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
